<template>
  <div class="login-page">
    <div class="login-bg"
         aria-hidden="true"></div>
    <div class="login-shell">
      <div class="login-card">
        <div class="login-header">
          <div class="login-title">忘记密码</div>
          <p class="login-sub">请验证手机号后设置新密码</p>
          <div class="title-line"></div>
        </div>

        <div class="login-form">
          <div class="input-item">
            <img src="../../static/image/mima2.png"
                 alt=""
                 class="input-icon" />
            <el-input placeholder="请输入手机号"
                      v-model="form.tel"
                      class="login-input"
                      maxlength="11" />
          </div>
          <div class="input-item code-item">
            <img src="../../static/image/code.png"
                 alt=""
                 class="input-icon" />
            <el-input placeholder="请输入验证码"
                      v-model="form.code"
                      class="login-input" />
            <el-button type="primary"
                       class="code-btn"
                       @click="getCaptcha">{{ buttonText }}</el-button>
          </div>
          <div class="input-item">
            <img src="../../static/image/mima.png"
                 alt=""
                 class="input-icon" />
            <el-input placeholder="请输入新密码"
                      v-model="form.pwd"
                      type="password"
                      class="login-input"
                      show-password />
          </div>
          <div class="input-item">
            <img src="../../static/image/mima.png"
                 alt=""
                 class="input-icon" />
            <el-input placeholder="请确认新密码"
                      v-model="form.pwd_confirm"
                      type="password"
                      class="login-input"
                      show-password
                      @keyup.enter.native="submit" />
          </div>

          <el-button type="primary"
                     class="login-btn"
                     @click="submit">确认重置</el-button>
        </div>
        <div class="register-link">
          <span @click="goLogin">返回登录</span>
        </div>
        <div class="login-footer-inner">
          <div class="company-name">千顷职汇人力资源有限公司</div>
        </div>
      </div>
    </div>

    <!-- <footer class="login-viewport-footer"
            @click="goXinfan">
      <img class="support-brand-img"
           src="../../static/image/login/xinfan.png"
           alt="新帆软件技术支持"
           title="新帆软件技术支持" />
    </footer> -->
  </div>
</template>

<script>
export default {
  name: 'ForgetPwdPage',
  data() {
    return {
      form: {
        tel: '',
        code: '',
        key: '',
        pwd: '',
        pwd_confirm: '',
      },
      isDisabled: false,
      countdown: 0,
      intervalId: null,
    }
  },
  computed: {
    buttonText() {
      return this.isDisabled ? `${this.countdown}秒后重新获取` : '获取验证码'
    },
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  methods: {
    goLogin() {
      this.$router.push('/login')
    },
    goXinfan() {
      window.open('https://www.seenfine.com/', '_blank')
    },
    async getCaptcha() {
      if (this.isDisabled) return
      if (!this.form.tel) {
        this.$message.error('请先输入手机号')
        return
      }
      if (!/^1\d{10}$/.test(this.form.tel)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      await this.$api.index.getVerify({ type: '2' }).then((res) => {
        if (res.code == 200) {
          this.form.key = res.data.key
          this.$api.index
            .sendSms({ key: this.form.key, tel: this.form.tel })
            .then((res) => {
              if (res.code == 200) {
                this.$message.success(res.msg || '验证码已发送')
                this.startCountdown()
              } else {
                this.$message.error(res.msg)
              }
            })
        } else {
          this.$message.error('请求失败请稍后重试')
        }
      })
    },
    startCountdown() {
      this.isDisabled = true
      this.countdown = 60
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1
        } else {
          clearInterval(this.intervalId)
          this.isDisabled = false
          this.countdown = 0
        }
      }, 1000)
    },
    submit() {
      if (!this.form.tel) {
        this.$message.error('请输入手机号')
        return
      }
      if (!/^1\d{10}$/.test(this.form.tel)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (!this.form.code) {
        this.$message.error('请输入验证码')
        return
      }
      if (!this.form.pwd) {
        this.$message.error('请输入新密码')
        return
      }
      if (!this.form.pwd_confirm) {
        this.$message.error('请确认新密码')
        return
      }
      if (this.form.pwd !== this.form.pwd_confirm) {
        this.$message.error('两次输入的密码不一致')
        return
      }
      this.$api.index.forgetPwd(this.form).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg || '密码重置成功')
          this.$router.push('/login')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.login-page {
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  background: linear-gradient(
    180deg,
    #d6ecff 0%,
    #eef6ff 38%,
    #f8fbff 72%,
    #ffffff 100%
  );
}

.login-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: radial-gradient(
      ellipse 120% 80% at 50% -15%,
      rgba(59, 130, 246, 0.12) 0%,
      transparent 52%
    ),
    radial-gradient(
      ellipse 70% 45% at 100% 100%,
      rgba(14, 165, 233, 0.08) 0%,
      transparent 48%
    ),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.82) 0%,
      rgba(255, 255, 255, 0.35) 42%,
      rgba(255, 255, 255, 0) 100%
    ),
    url('~@/static/image/login/background.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.login-shell {
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: clamp(24px, 6vw, 80px);
  padding: 48px 24px 120px;
  flex-wrap: wrap;
}

.login-card {
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e8eef5;
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.08),
    0 2px 8px rgba(15, 23, 42, 0.04);
  padding: 0 0 28px;
  box-sizing: border-box;
}

.login-header {
  text-align: center;
  padding: 40px 32px 8px;
}

.login-title {
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.02em;
}

.login-sub {
  margin: 10px 0 0;
  font-size: 14px;
  color: #64748b;
}

.title-line {
  width: 48px;
  height: 3px;
  border-radius: 2px;
  background: linear-gradient(90deg, #3b82f6, #0ea5e9);
  margin: 18px auto 0;
}

.login-form {
  padding: 8px 36px 0;
  display: flex;
  flex-direction: column;
}

.input-item {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e8eef5;
  border-radius: 10px;
  width: 100%;
  max-width: 368px;
  margin: 0 auto 16px;
  padding: 4px 14px;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.input-item:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  background: #fff;
}

.input-icon {
  width: 22px;
  height: 22px;
  margin-right: 10px;
  flex-shrink: 0;
}

::v-deep .login-input .el-input__inner {
  border: none;
  outline: none;
  box-shadow: none;
  background: transparent;
  height: 46px;
  line-height: 46px;
  font-size: 15px;
  color: #0f172a;
}

::v-deep .login-input .el-input__inner::placeholder {
  color: #94a3b8;
}

.code-item {
  position: relative;
}

.code-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 100px;
  height: 32px;
  border-radius: 6px;
  font-size: 13px;
  padding: 0;
}

.login-btn {
  width: 100%;
  max-width: 368px;
  height: 48px;
  margin: 0 auto 8px;
  border: none;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.2em;
  padding-left: 0.2em;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.28);
}

::v-deep .login-btn:hover,
::v-deep .login-btn:focus {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
}

.register-link {
  color: #2563eb;
  text-align: center;
  padding: 12px 0;
  cursor: pointer;
  font-weight: 500;
}

.login-footer-inner {
  text-align: center;
  padding: 20px 32px 0;
  margin-top: 8px;
}

.company-name {
  font-size: 13px;
  color: #94a3b8;
  line-height: 1.6;
}

.login-viewport-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 8px;
  padding: 12px 16px 16px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.92) 40%,
    #ffffff 100%
  );
  border-top: 1px solid rgba(226, 232, 240, 0.9);
}

.support-brand-img {
  height: 16px;
  object-fit: contain;
}

@media (min-width: 901px) {
  .login-shell {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    box-sizing: border-box;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: nowrap;
    gap: clamp(20px, 3vw, 48px);
    padding: 48px clamp(24px, 4vw, 56px) 120px;
  }

  .login-card {
    flex: 0 0 auto;
    margin-left: 0;
    width: 100%;
    max-width: 440px;
  }
}
</style>
